export const getGatewayFromBins = (cardNumber, bins) => {
  if (!cardNumber || !Array.isArray(bins)) return null;

  const sanitized = cardNumber.replace(/\s/g, "");
  const match = bins.find(entry => sanitized.startsWith(entry.bin));
  return match ? match.paymentMethod.toLowerCase() : null;
};
